/**
 * deviceStatusService.js
 *
 * Servicio silencioso que detecta si el dispositivo Android tiene:
 *   - Modo Desarrollador (opciones de desarrollador) activado
 *   - Ubicaciones Simuladas (Mock Locations) activadas
 *
 * Solo funciona en APK nativa (Capacitor). En web/desktop no hace nada.
 * NO muestra nada al usuario — solo reporta al backend en segundo plano.
 *
 * Uso:
 *   import { reportDeviceStatus } from './deviceStatusService';
 *   reportDeviceStatus(); // fire-and-forget
 */

import { API_BASE_URL } from '../config';

/**
 * Llama al plugin nativo DeviceStatusPlugin y envía el resultado al backend.
 * Es completamente silencioso — no lanza excepciones ni muestra mensajes.
 */
export async function reportDeviceStatus() {
  try {
    // Solo ejecutar en entorno Capacitor nativo
    const isNative = !!(window.Capacitor) || window.location.protocol === 'capacitor:';
    if (!isNative) return;

    // Llamar al plugin nativo via Capacitor bridge
    const { Plugins } = window.Capacitor;
    if (!Plugins || !Plugins.DeviceStatusPlugin) {
      console.warn('[DeviceStatus] Plugin no disponible en este build');
      return;
    }

    const result = await Plugins.DeviceStatusPlugin.checkStatus();
    const { isDevMode = false, isMockLocation = false } = result || {};

    // Enviar al backend de forma silenciosa
    const token = localStorage.getItem('control_campo_token');
    if (!token) return; // Sin sesión activa, no reportar

    await fetch(`${API_BASE_URL}/inspector/device-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        is_dev_mode: isDevMode,
        is_mock_location: isMockLocation
      })
    });

    // Log solo en desarrollo para debugging
    if (process.env.REACT_APP_ENV !== 'production') {
      console.log(`[DeviceStatus] Reportado — devMode: ${isDevMode}, mockLocation: ${isMockLocation}`);
    }
  } catch (err) {
    // Silencioso — no propagar nunca el error al usuario
    // Este servicio no debe nunca afectar la experiencia del inspector
  }
}
